module.exports = __webpack_public_path__ + "img/FR10268.4c907ccc.png";